module.exports = __webpack_public_path__ + "static/media/4-_DSC7160.73f4df45.jpg";